// Shared wine pricing/formatting helpers and types.
// Single source of truth used by both the Master Products page and the Alerts page
// so deal thresholds and formatting can never diverge between the two.

export interface CriticReviewData {
    reviewId?: string;
    criticName?: string;
    criticSource?: string;
    score?: string;
    reviewDate?: string;
    reviewText?: string;
}

export interface MetricRow {
    label: string;
    price?: number | null;
    date?: string | null;
    // Optional "this listing vs this reference" percentage, rendered under the price.
    comparison?: number | null;
}

export interface ComparisonRow {
    label: string;
    percentage?: number | null;
}

// Deal-quality colour bands for a price-vs-reference percentage.
export const getPriceIndicator = (percentage: number) => {
    if (percentage < -20) return { color: '#166534', bg: '#bbf7d0', label: 'Great Deal!' };
    if (percentage < -10) return { color: '#15803d', bg: '#dcfce7', label: 'Good Deal' };
    if (percentage < 0) return { color: '#047857', bg: '#d1fae5', label: 'Fair Deal' };
    if (percentage < 10) return { color: '#334155', bg: '#e2e8f0', label: 'Market Price' };
    return { color: '#dc2626', bg: '#fecaca', label: 'Overpriced' };
};

export const formatPercentage = (percentage: number | undefined | null) => {
    if (percentage === undefined || percentage === null) return 'N/A';
    return `${percentage > 0 ? '+' : ''}${percentage.toFixed(1)}%`;
};

// For "vs Highest Bid": above the bid is bad (red), below is good (green).
export const getVsHighestBidColor = (percentage: number | undefined | null) => {
    if (percentage === undefined || percentage === null) return '#6b7280';
    return percentage >= 0 ? '#dc2626' : '#166534';
};

export const formatPriceWithDate = (price: number | undefined | null, date: string | undefined | null) => {
    if (!price || price === 0) return 'N/A';
    const formattedPrice = `£${price.toLocaleString()}`;
    if (date) {
        const formattedDate = new Date(date).toLocaleDateString('en-GB');
        return `${formattedPrice} (${formattedDate})`;
    }
    return formattedPrice;
};
